import { hierarchyNodeActions } from '../../services';

function addParentToNode( node, parentNode ) {
  node.parent = parentNode;
  if ( node.children ) {
    node.children.forEach( child => addParentToNode( child, node ) );
  }
  return node;
}

// we only want to show the enabled nodes, to reduce the choices
function filterNodes( node ) {
  return {...node, children: node.children.where( child => child.isEnabled && child.nodeId ).select( filterNodes ) };
}

export const hierarchyNodeReducer = ( state = {}, action ) => {
  switch ( action.type ) {
    case hierarchyNodeActions.LOAD:
      return addParentToNode( Object.assign( { }, filterNodes( action.node ) ), null );
    default:
      return state;
  }
};